import { render } from "./ContestatiiPage.vue?vue&type=template&id=b466a40c"
import script from "./ContestatiiPage.vue?vue&type=script&lang=js"
export * from "./ContestatiiPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__